import { MerchantState } from './merchant.models';
import { createReducer, Action } from '@ngrx/store';

export const initialState: MerchantState = {
  merchant_field             : undefined,
  additional_info            : undefined
};

const reducer = createReducer(
  initialState,

  // on(successWalletSignIn, (state, action) => {
  //   return {
  //     ...state,
  //     // field: 'new',
  //   }
  // }),
);

export function merchantReducer(
  state: MerchantState | undefined,
  action: Action
): MerchantState {
  return reducer(state, action);
}
